<script lang="ts">
	import type { User } from 'lucia';
	import { slide } from 'svelte/transition';

	interface Props {
		user: User | undefined;
	}

	let { user }: Props = $props();
</script>

{#if user && !user.emailVerified}
	<div class="w-full bg-foreground" transition:slide>
		<div class="container mx-auto py-1.5">
			<p class="text-center text-sm text-background">
				Bitte
				<a href="/email-verifizieren" class="font-medium underline">bestätige deine Email</a>
				Adresse, um alle Funktionen freizuschalten.
			</p>
		</div>
	</div>
{/if}
